import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';

/**
 * API通信共通処理
 * @param {object} self 呼び出し元インスタンス
 * @param {string} type リクエストのtype
 * @param {async () => {}} completedCallback status: completed のときのコールバック関数
 * @param {async () => {}} failedCallback status: failed のときのコールバック関数
 * @param {boolean} isOnlyExecution 結果見ない場合true
 * @param {number} intError 0以外の場合エラー遷移なし
 */
export async function executeApi(
  self,
  type,
  completedCallback,
  failedCallback = async (self) => { self.showUnexpectedError(); },
  isOnlyExecution = false,
  intError = 0
) {
  try {
    self.isLoading = true;
    const token = session.getToken();
    // データ読み出し(要求)（バックエンドAPI_POST）
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: type,
      },
      //  エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      (errorType) => { errorType; self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
    );

    if (isOnlyExecution || !response) return; // API結果見ない or response存在しない場合
    if (intError !== 0) { self.closeWizard(); return; } // エラー遷移せず機能終了

    switch (response.data?.status) {
      // 正常終了
      case REQUEST_STATUS_COMPLETED:
        await completedCallback(self, response);
        break;
      // 異常終了
      case REQUEST_STATUS_FAILED:
      default:
        await failedCallback(self);
        break;
    }
  } finally {
    self.isLoading = false;
  }
}

/**
 * res_typeを確認する場合のstatus === 'completed' 時共通処理
 * @param {object} self 呼び出し元インスタンス
 * @param {object} response APIレスポンス
 * @param {async () => {}} okResultCallback res_type: ok のときのコールバック関数
 * @param {async () => {}} ngResultCallback res_type: ng のときのコールバック関数
 */
export async function handleResponseType(
  self,
  response,
  okResultCallback,
  ngResultCallback
) {
  if (response.data.user_data.res_type === 'ok') {
    await okResultCallback(self);
  } else {
    await ngResultCallback(self);
  }
}

/**
 * resultを確認する場合のstatus === 'completed' 時共通処理
 * @param {object} self 呼び出し元インスタンス
 * @param {object} response APIレスポンス
 * @param {async () => {}} awdResultCallback result: awd のときのコールバック関数
 * @param {async () => {}} ffResultCallback result: ff のときのコールバック関数
 * @param {async () => {}} ngResultCallback result: ng のときのコールバック関数
 */
export async function handleResult(
  self,
  response,
  awdResultCallback,
  ffResultCallback,
  ngResultCallback = async (self) => { self.showUnexpectedError(); }
) {
  switch (response.data.user_data.result) {
    case 'awd':
      await awdResultCallback(self);
      break;
    case 'ff':
      await ffResultCallback(self);
      break;
    case 'ng':
    default:
      await ngResultCallback(self);
      break;
  }
}